






























































import { computed, defineComponent, onBeforeMount, reactive, toRefs, getCurrentInstance, ref,onMounted } from '@vue/composition-api'
import Alerts, { AlertType } from '@/code/alerts'
import { Home, Search, FormatDate } from '@/views/Home.vue'
import { HttpPOST, tablas, RedirecPagMantenimiento } from '@/code/Utils'
import Pagination from '@/components/pagination.vue'
import VueRouter from 'vue-router'

export default defineComponent({
    name: "tablaIngresar",
    components: {
    Pagination
},
    setup(props, context) {

        const progressBarRefDiv =  ref<HTMLElement | null>(null);
        const btnEnviar =  ref<HTMLElement | null>(null);
        
        const base = reactive({
            xml: ""
        })

        const state = reactive({
            porcentajeLenght: 100,
            porcentajeBarValue : 0,
        })
        const aumentoPorcentaje = (numero: number) => {
            state.porcentajeBarValue = numero;
        };
        /*
        const miComponenteHijoRef = ref<typeof progressBar |null>(null) ;
        const aumentoPorcentaje = onMounted(() =>{
            miComponenteHijoRef.value.aumentoPorcentaje(numero)
        }
        
        const cambiarPorcentajeProgressBar = (numero : number) => {
            const instance = getCurrentInstance();
            const referenciaProgressBar = instance.refs.ProgressBar as { aumentoPorcentaje: (numero: number) => void };            
            referenciaProgressBar.aumentoPorcentaje(numero);
        }
        */
        const tablaIngresar = computed(() => {
            return (Home.tablas.ingresar.filter(item => { return item.show })).slice(Home.pagination.page * Home.pagination.rowPerPage, Home.pagination.page * Home.pagination.rowPerPage + Home.pagination.rowPerPage) as tablas[];
        })

        const ObtenerDDJJ = async () => {
            //debugger;
            const alert = document.querySelector(".pol-alert");
            if (alert)
                alert.classList.remove('show');
            Home.tablas.ingresar = [];
            const date = Date.parse(Home.date);
            const min = Date.parse(Home.min);
            if(date >= min){
                let ddjj_id;
                if (Home.date != '') {
                    context.root.$store.commit('ChangeLoader', true)                    
                    var compamia = context.root.$store.state.session.companyCode;
                    // console.log("---Compania-----");
                    // console.log(compamia);
                    // console.log("---Compania-----");
                    const response = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                                                <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                                <soap12:Body>
                                                    <getCabPosByCompanyCodeVF xmlns="http://tempuri.org/">
                                                    <companyCode>${context.root.$store.state.session.companyCode}</companyCode>
                                                    <fechaini>${FormatDate(Home.date)}</fechaini>
                                                    <fechafin></fechafin>
                                                    <estado>L</estado>
                                                    </getCabPosByCompanyCodeVF>
                                                </soap12:Body>
                                                </soap12:Envelope>`, null) as XMLHttpRequest;
                    const Xml = response.responseXML;
                    console.log(response.responseXML);
                    const items = Xml.getElementsByTagName('Z_InsertsUpdates');   
                    //  console.log("---------Response items------------")
                    //  console.log(items);

                    if(await RedirecPagMantenimiento(response.status,context)){
                                               
                        //Recorrer las ddjj                                                                               
                        for (var i = 0; i < items.length; i++) {
                            const current = items[i];
                            const Cabecera = current.getElementsByTagName('Cabecera')[0];
                            const PosicionList = current.getElementsByTagName('PosicionList')[0];
                            // console.log(i);
                            // console.log(items[i]);
                            // console.log(Cabecera);
                            // console.log(PosicionList);
                            const PosicionItems = PosicionList.getElementsByTagName('Z_CustomerSystem_DJ_Posicion');
                            //console.log(PosicionItems);
                            //const date = Cabecera.getElementsByTagName('Fecha_reg')[0].textContent;
                            // if (Home.date == date.split('T')[0]) {
                                // console.log("------Response items for------------")
                                // console.log(items[i]);    
                                // console.log("--Id declaracion---");
                                // console.log(Cabecera.getElementsByTagName('Id_declaracion')[0].textContent);
                                // console.log(Cabecera.getElementsByTagName('Nro_contrato')[0].textContent);
                                
                                if (PosicionItems.length > 0) {
                                    const moneda = Cabecera.getElementsByTagName('Moneda_des')[0].textContent;
                                    
                                    console.log("PosicionesItems : " + PosicionItems.length);
                                    for (var index = 0; index < PosicionItems.length; index++) {
                                        const item = {
                                            Id_declaracion: Cabecera.getElementsByTagName('Id_declaracion')[0].textContent,
                                            Cod_cliente: Cabecera.getElementsByTagName('Cod_cliente')[0].textContent,
                                            Fecha: Cabecera.getElementsByTagName('Fecha')[0].textContent,
                                            Nro_contrato: Cabecera.getElementsByTagName('Nro_contrato')[0].textContent,
                                            Moneda: Cabecera.getElementsByTagName('Moneda')[0].textContent,
                                            Moneda_des: moneda.charAt(0).toUpperCase() + moneda.slice(1).toLowerCase(),
                                            Tipo_cambio: Cabecera.getElementsByTagName('Tipo_cambio')[0].textContent,
                                            Estado: Cabecera.getElementsByTagName('Estado')[0].textContent,
                                            Fecha_reg: Cabecera.getElementsByTagName('Fecha_reg')[0].textContent,
                                            Id_usuario: Cabecera.getElementsByTagName('Id_usuario')[0].textContent,
                                            Id_historial: Cabecera.getElementsByTagName('Id_historial')[0].textContent,
                                            Id_posicion: PosicionItems[index].getElementsByTagName('Id_posicion')[0].textContent,
                                            Importe: PosicionItems[index].getElementsByTagName('Importe')[0].textContent,
                                            Local: PosicionItems[index].getElementsByTagName('Local')[0] ? PosicionItems[index].getElementsByTagName('Local')[0].textContent : "",
                                            Rubro: PosicionItems[index].getElementsByTagName('Rubro')[0].textContent,
                                            Id_rubro: PosicionItems[index].getElementsByTagName('Id_rubro')[0].textContent,
                                            Cantidad: PosicionItems[index].getElementsByTagName('Cantidad')[0].textContent,
                                            show: true
                                        }
                                        Home.tablas.ingresar.push(item)
                                    }
                                }
                                ddjj_id = Cabecera.getElementsByTagName('Id_declaracion')[0].textContent;
                            // }
                        }
                        Home.pagination.count = Home.tablas.ingresar.length;
                        Home.pagination.pages = Math.ceil(Home.tablas.ingresar.length / Home.pagination.rowPerPage);
                        context.root.$store.commit('ChangeLoader', false);
                    }                    
                }
            } else {
                Alerts.Throw('El campo "Fecha" debe ser mayor a 60 días.', AlertType.Danger, false, 5000)
            }
        }

        const IngresarDDJJ = async () => {
            let declaration_id;
            //Ocultar boton enviar
            btnEnviar.value.style.display = 'none';
            progressBarRefDiv.value.style.display = 'block';
            aumentoPorcentaje(10);
            console.log("Contado de tablas : "+ tablaIngresar.value.length);
            console.log("Contado de tablas HOME: "+ Home.tablas.ingresar.length);            
            const items = Home.tablas.ingresar;            
            let nroContrato = ""; 
            let contadorCabecera = 0;
            let cantidadContratos = 0;
            let array = [];
            //For Cantidad de cotratos
            for(var index = 0; index <  Home.tablas.ingresar.length; index++){
                
                const current = Home.tablas.ingresar[index] as tablas;
                if(nroContrato != items[index].Nro_contrato){
                    
                    nroContrato = items[index].Nro_contrato;
                    cantidadContratos = cantidadContratos + 1; 
                    // console.log(index);
                    // console.log(current.Id_declaracion);
                    // array[index] = current.Id_declaracion;
                    //declaration_id = (declaration_id != current.Id_declaracion) ? current.Id_declaracion : current.Id_declaracion;
                    
                    console.log(cantidadContratos);
                    //  console.log("declaration_id " + current.Id_declaracion);
                    // console.log("declaration_id " + declaration_id);
                }
               
                if(cantidadContratos > 1)
                {
                    declaration_id = 0;
                    var idDeclaracion_PrimeraPosicion = Home.tablas.ingresar[0].Id_declaracion;
                     if(idDeclaracion_PrimeraPosicion != current.Id_declaracion)
                     {
                         declaration_id = declaration_id  + 1;  
                     }
                     else{
                        declaration_id = 0;                     
                    }
                }
                else{
                    declaration_id = current.Id_declaracion;
                }
                console.log(declaration_id);
            }
           
            console.log("Cantidad contratos : " + cantidadContratos);
            let responseExist;
            //Enviando datos al servidor
            for (var index = 0; index < cantidadContratos; index++) {
                const current = Home.tablas.ingresar[index] as tablas;
               
                if (index < Home.tablas.ingresar.length) {
                    //declaration_id = current[0].Id_declaracion;
                    nroContrato = "";

                    //const items = tablaIngresar.value.length > 1 ? tablaIngresar.value.filter(e => { return e.Id_declaracion === declaration_id }) : tablaIngresar.value;
                    
                    /*console.log("Id_Declaracion : " + parseInt(current.Id_declaracion));
                    console.log("Current - " + current);
                    console.log(current);
                    console.log("items - " + items);
                    console.log(items.length);*/
                    //console.log(items[contadorCabecera].Nro_contrato);
                    contadorCabecera = (contadorCabecera > 0) ? contadorCabecera : 0;

                    if(nroContrato != items[contadorCabecera].Nro_contrato){
                        nroContrato = items[contadorCabecera].Nro_contrato; 
                        console.log(nroContrato);
                        console.log("id declaracion : " + declaration_id);
                        responseExist = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                                                            <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                                            <soap12:Body>
                                                                <getCabPos xmlns="http://tempuri.org/">
                                                                <idDeclaracion>${parseInt(declaration_id)}</idDeclaracion>
                                                                </getCabPos>
                                                            </soap12:Body>
                                                            </soap12:Envelope>`, null) as XMLHttpRequest;
                    }

                    
                    //console.log(items);
                    //return;
                    
                

                    // const responseExist2 = await HttpPOST(`<?xml version="1.0" encoding="utf-8"?>
                    //                                         <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
                    //                                         <soap:Body>
                    //                                             <getCabPos xmlns="http://tempuri.org/">
                    //                                             <idDeclaracion>${parseInt(declaration_id)}</idDeclaracion>
                    //                                             </getCabPos>
                    //                                         </soap:Body>
                    //                                         </soap:Envelope>`, null) as XMLHttpRequest;   
                    // console.log("\n-------------Primera llamada de exist----------------------\n");                                                     
                    const xmlExist = responseExist.responseXML;
                   
                    let fechaConvert = (parseInt(items[contadorCabecera].Id_declaracion) != 0) ? items[contadorCabecera].Fecha : new Date().toISOString();
                    let fechaConvert1 = (parseInt(items[contadorCabecera].Id_declaracion) != 0) ? new Date().toISOString(): items[contadorCabecera].Fecha_reg ;
                    
                    let xml = `<?xml version="1.0" encoding="utf-8"?>
                                    <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                                    <soap12:Body>`;                                  
                    
                    
                    console.log("Contador contrato : " + contadorCabecera);
                    
                    let xmlCabecera = `
                        <insertsUpdatesCabPos xmlns="http://tempuri.org/">
                        <CabPos>
                            <Cabecera>
                            <Id_declaracion>${parseInt(items[contadorCabecera].Id_declaracion)}</Id_declaracion>
                            <Cod_cliente>${items[contadorCabecera].Cod_cliente}</Cod_cliente>
                            <Fecha>${fechaConvert}</Fecha>
                            <Nro_contrato>${items[contadorCabecera].Nro_contrato}</Nro_contrato>
                            <Moneda>${items[contadorCabecera].Moneda}</Moneda>
                            <Moneda_des>${items[contadorCabecera].Moneda_des}</Moneda_des>
                            <Tipo_cambio>${parseInt(items[contadorCabecera].Tipo_cambio).toFixed(2)}</Tipo_cambio>
                            <Estado>${items[contadorCabecera].Estado}</Estado>
                            <Fecha_reg>${fechaConvert1}</Fecha_reg>
                            <Id_usuario>${parseInt(items[contadorCabecera].Id_usuario)}</Id_usuario>
                            <Id_historial>${parseInt(items[contadorCabecera].Id_historial)}</Id_historial>
                            </Cabecera>
                            <PosicionList>`
                        xml = xml + xmlCabecera;

                        for (var i = 0; i < Home.tablas.ingresar.length; i++) 
                        {
                            if(nroContrato == items[i].Nro_contrato){
                                const XmlPosicion = `<Z_CustomerSystem_DJ_Posicion>
                                                <Id_posicion>${parseInt(items[i].Id_posicion)}</Id_posicion>
                                                <Id_declaracion>${parseInt(items[i].Id_declaracion)}</Id_declaracion>
                                                <Importe>${parseFloat(items[i].Importe)}</Importe>
                                                <Local>${items[i].Local}</Local>
                                                <Rubro>${items[i].Rubro}</Rubro>
                                                <Id_rubro>${items[i].Id_rubro}</Id_rubro>
                                                <Cantidad>${parseInt(items[i].Cantidad).toFixed(2)}</Cantidad>
                                            </Z_CustomerSystem_DJ_Posicion>`
                                xml = xml + XmlPosicion;
                                contadorCabecera = contadorCabecera + 1;
                                
                            }                           
                            //console.log(parseInt(items[i].Cantidad).toFixed(2));
                            aumentoPorcentaje(items.length/100 + 10);
                        }      
                        console.log("Contador cabecera : fin del for " + contadorCabecera);
                        // xml = xml + `</PosicionList>
                        //             </CabPos>
                        //             <Update>${xmlExist.getElementsByTagName("Z_CustomerSystem_DJ_Posicion").length == 0 ? 0 : 1}</Update>
                        //             </insertsUpdatesCabPos>
                        //         </soap12:Body>
                        //         </soap12:Envelope>`;
                        if(declaration_id == 0 || declaration_id == 1){
                            xml = xml + `</PosicionList>
                                    </CabPos>
                                    <Update>${declaration_id == 0 ? 0 : 1}</Update>
                                    </insertsUpdatesCabPos>
                                </soap12:Body>
                                </soap12:Envelope>`;    
                        }
                        else{
                            xml = xml + `</PosicionList>
                                    </CabPos>
                                    <Update>${xmlExist.getElementsByTagName("Z_CustomerSystem_DJ_Posicion").length == 0 ? 0 : 1}</Update>
                                    </insertsUpdatesCabPos>
                                </soap12:Body>
                                </soap12:Envelope>`;   
                        }
                                                        

                        base.xml = xml;
                        console.log("xml : " + xml);

                      
                          
                    const response = await HttpPOST(xml, null) as XMLHttpRequest; 
                    // console.log(response);
                    /*
                    const response = await HttpPOST(xml, null) as XMLHttpRequest; //Aca se envian los datos al servidor
                    const XML = response.responseXML;
                    const response_items = XML.getElementsByTagName("ResponsePosicion");
                    for (var i = 0; i < response_items.length; i++) {
                        const current = response_items[i];
                        if (current.getElementsByTagName("CodResult")[0].textContent != "OK") {
                            ObtenerDDJJ();
                            Alerts.Throw("Ocurrio un error al intentar, por favor intente nuevamente.", AlertType.Danger, false, 5000)
                            return;
                        }
                    }
                    */
                }
            }            
            aumentoPorcentaje(100);
            Alerts.Throw("La información suministrada se envió correctamente.", AlertType.Success, false, 5000);
            progressBarRefDiv.value.classList.add('miElemento');
            setTimeout(() => {
                progressBarRefDiv.value.style.display = 'none';
                btnEnviar.value.style.display = 'block';
            }, 3000);
            
            
        }

        const SaveDDJJ = async (item: tablas, items: tablas[]) => {
            let xml = `<?xml version="1.0" encoding="utf-8"?>
                        <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
                        <soap12:Body>
                            <insertsUpdatesCabPos xmlns="http://tempuri.org/">
                            <CabPos>
                                <Cabecera>
                                <Id_declaracion>${parseInt(item.Id_declaracion)}</Id_declaracion>
                                <Cod_cliente>${item.Cod_cliente}</Cod_cliente>
                                <Fecha>${new Date().toISOString()}</Fecha>
                                <Nro_contrato>${item.Nro_contrato}</Nro_contrato>
                                <Moneda>${item.Moneda}</Moneda>
                                <Moneda_des>${item.Moneda_des}</Moneda_des>
                                <Tipo_cambio>${parseInt(item.Tipo_cambio).toFixed(2)}</Tipo_cambio>
                                <Estado>${item.Estado}</Estado>
                                <Fecha_reg>${item.Fecha_reg}</Fecha_reg>
                                <Id_usuario>${parseInt(item.Id_usuario)}</Id_usuario>
                                <Id_historial>${parseInt(item.Id_historial)}</Id_historial>
                                </Cabecera>
                                <PosicionList>`;

            for(var i = 0; i < items.length; i++) {
                const XmlToAdd = `<Z_CustomerSystem_DJ_Posicion>
                                    <Id_posicion>${parseInt(items[i].Id_posicion)}</Id_posicion>
                                    <Id_declaracion>${parseInt(items[i].Id_declaracion)}</Id_declaracion>
                                    <Importe>${parseInt(items[i].Importe).toFixed(2)}</Importe>
                                    <Local>${items[i].Local}</Local>
                                    <Rubro>${items[i].Rubro}</Rubro>
                                    <Id_rubro>${items[i].Id_rubro}</Id_rubro>
                                    <Cantidad>${parseInt(items[i].Cantidad).toFixed(2)}</Cantidad>
                                </Z_CustomerSystem_DJ_Posicion>`
                xml = xml + XmlToAdd;
            }
            xml = xml + `</PosicionList>
                            </CabPos>
                            <Update>0</Update>
                            </insertsUpdatesCabPos>
                        </soap12:Body>
                        </soap12:Envelope>`;
            
            base.xml = xml;
            debugger;
            const response = await HttpPOST(xml, null) as XMLHttpRequest;
            const XML = response.responseXML;
            const response_items = XML.getElementsByTagName("ResponsePosicion");
            for (var i = 0; i < response_items.length; i++) {
                const current = response_items[i];
                if (current.getElementsByTagName("CodResult")[0].textContent != "OK") {
                    ObtenerDDJJ();
                    Alerts.Throw("Ocurrio un error al intentar, por favor intente nuevamente.", AlertType.Danger, false, 5000)
                    return;
                }
            }
            
            Alerts.Throw("La información suministrada se envió correctamente.", AlertType.Success, false, 5000);
        }

        onBeforeMount(() => {
            ObtenerDDJJ();
        })

        return {
            ...toRefs(context.root.$store.state),
            ...toRefs(Home),
            ...toRefs(base),
            tablaIngresar,
            ObtenerDDJJ,
            IngresarDDJJ,
            Search,
            FormatDate,
            state,
            aumentoPorcentaje,
            progressBarRefDiv,
            btnEnviar
            //cambiarPorcentajeProgressBar       
        }
    }
})
